"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POPUP_EVENTS = void 0;
exports.POPUP_EVENTS = {
    BANK_POPUP_SHOW: "BANK_POPUP_SHOW",
    BANK_POPUP_CLOSE: "BANK_POPUP_CLOSE",
    BANK_POPUP_VISIBILITY_CHANGE: "BANK_POPUP_VISIBILITY_CHANGE"
};
